// helpers
import {extendTheme, Theme} from '@mui/joy';
import {lighten, darken} from '@mui/system';

// types
import {PortalConfig} from '../../services/ApiService/types/endpoints';

/**
 * Generate custom Joy UI theme to be used in the app
 * @param portalConfig
 */
export const generateCustomJoyUITheme = (
  portalConfig: PortalConfig | null,
): Theme => {
  if (portalConfig === null) {
    return extendTheme({});
  }

  const {primaryColor} = portalConfig;

  const customJoyUITheme = extendTheme({
    colorSchemes: {
      light: {
        palette: {
          primary: {
            50: lighten(primaryColor, 0.8),
            100: lighten(primaryColor, 0.6),
            200: lighten(primaryColor, 0.4),
            300: lighten(primaryColor, 0.2),
            400: lighten(primaryColor, 0.1),
            500: primaryColor,
            600: darken(primaryColor, 0.1),
            700: darken(primaryColor, 0.2),
            800: darken(primaryColor, 0.3),
            900: darken(primaryColor, 0.4),
          },
        },
      },
    },
    components: {
      // Target all components
      JoyButton: {
        styleOverrides: {
          root: ({ownerState}) => ({
            borderRadius: 12,
            borderWidth: 2,
            ...(ownerState.variant === 'outlined' && {
              "backgroundColor": 'white',
              '&:hover': {
                backgroundColor: lighten(primaryColor, 0.9),
              },
            }),
            ...(ownerState.variant === 'plain' && {
              '&:hover': {
                backgroundColor: lighten(primaryColor, 0.9),
              },
            }),
          }),
        },
      },
    },
  });

  return customJoyUITheme;
};
